<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useKpiStore } from '@/stores/useKpiStore'

import { printCurrency } from '@/utils/numbers'
import { InformationCircleIcon } from '@heroicons/vue/24/outline'
import IconWithTooltip from '@/components/common/ui/IconWithTooltip.vue'

const kpiStore = useKpiStore()
const { kpisOpportunities, loadingKpiOpp, errorKpi } = storeToRefs(kpiStore)
</script>

<template>
  <div v-if="loadingKpiOpp" class="flex justify-center py-8">
    <span class="loading loading-spinner loading-lg"></span>
  </div>
  <div v-else-if="errorKpi" class="alert alert-error text-sm">
    {{ errorKpi }}
  </div>
  <div v-else-if="!kpisOpportunities.length" class="text-center text-base-content/60 py-8">
    Aucune donnée disponible.
  </div>
  <div v-else class="grid grid-cols-1 w-full items-center gap-2">
    <div class="col-span-1 grid grid-cols-1 place-items-center gap-4 sm:grid-cols-2">
      <div
        v-for="(kpi, index) in kpisOpportunities"
        :key="index"
        class="bg-base-100 p-1 rounded-2xl w-full col-span-1"
      >
        <h2 class="text-lg text-center py-2">
          {{ kpi.name }}
          <icon-with-tooltip :text="kpi.description" :rounded="true" variant="ghost">
            <InformationCircleIcon class="w-4 h-4" />
          </icon-with-tooltip>
        </h2>
        <div className="stats stats-vertical lg:stats-horizontal w-full">
          <div className="stat place-items-center p-4">
            <div className="stat-title">Nombre Affaires</div>
            <div className="stat-value">{{ kpi.count }}</div>
          </div>

          <div className="stat place-items-center p-4 ">
            <div className="stat-title">Montant total</div>
            <div className="stat-value">{{ printCurrency(Number(kpi.total)) }}</div>
          </div>

          <div className="stat place-items-center p-4">
            <div className="stat-title">Panier moyen</div>
            <div className="stat-value">{{ printCurrency(Number(kpi.average)) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
